export default __webpack_public_path__ + "static/media/Right.558649fb.svg";